import FaceTecSDK, { FaceTecInitializationError } from "facetec-sdk";

class FaceTecInitError extends Error {
  constructor(readonly error: FaceTecInitializationError) {
    super(
      `FaceTec SDK initialization failed: \
${FaceTecSDK.FaceTecInitializationError[error]} (${error})`,
    );

    // Keep `instanceof` working when compiled to ES5.
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export default FaceTecInitError;
